import React from 'react';

const styles = {
  container: { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
  group: { display: 'flex', flexDirection: 'column', gap: 4 },
  label: { fontSize: 11, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' },
  select: {
    background: '#0f172a', border: '1px solid #334155', borderRadius: 4, color: '#e2e8f0',
    padding: '6px 10px', fontSize: 13, minWidth: 80, cursor: 'pointer',
  },
  dash: { color: '#64748b', fontSize: 16, padding: '16px 4px 0' },
  info: { fontSize: 12, color: '#64748b', padding: '16px 0 0 8px' },
  availBadge: {
    fontSize: 10, padding: '2px 6px', borderRadius: 3, marginLeft: 6,
    display: 'inline-block', verticalAlign: 'middle',
  },
};

function yearOptions(min, max) {
  const years = [];
  for (let y = min; y <= max; y++) years.push(y);
  return years;
}

const YearRangeSelector = ({ startYear, endYear, onStartChange, onEndChange, availableMin, availableMax, availabilityStatus }) => {
  const years = yearOptions(availableMin || 2005, availableMax || 2024);
  const count = endYear - startYear + 1;
  const hours = count * 8760;

  const statusColor = {
    live: '#22c55e',
    cached: '#3b82f6',
    fallback: '#f59e0b',
  };

  return (
    <div style={styles.container}>
      <div style={styles.group}>
        <label style={styles.label}>Start Year</label>
        <select style={styles.select} value={startYear} onChange={(e) => onStartChange(parseInt(e.target.value))}>
          {years.map(y => (
            <option key={y} value={y} disabled={y > endYear}>{y}</option>
          ))}
        </select>
      </div>
      <span style={styles.dash}>&mdash;</span>
      <div style={styles.group}>
        <label style={styles.label}>End Year</label>
        <select style={styles.select} value={endYear} onChange={(e) => onEndChange(parseInt(e.target.value))}>
          {years.map(y => (
            <option key={y} value={y} disabled={y < startYear}>{y}</option>
          ))}
        </select>
      </div>
      <div style={styles.info}>
        {count} year{count !== 1 ? 's' : ''} &middot; ~{hours.toLocaleString()} hours
        {availabilityStatus && (
          <span style={{ ...styles.availBadge, background: statusColor[availabilityStatus] || '#475569', color: '#fff' }}>
            {availabilityStatus}
          </span>
        )}
      </div>
    </div>
  );
};

export default YearRangeSelector;
